<template>
  <div class="container">
    <div class="details-mark">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>课件中心</el-breadcrumb-item>
        <el-breadcrumb-item>课件详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="details-title">{{ detailData.name }}</div>
    <div class="detail-information">
      阅读量：<span>{{ detailData.hits_number }}</span>
      <el-divider direction="vertical"></el-divider>
      订阅量：<span>{{ detailData.subscribe_number }}</span>
      <el-divider direction="vertical"></el-divider>
      下载量：<span>{{ detailData.download_number }}</span>
    </div>
    <div class="detail-img">
      <img :src="(detailData.image || {}).file_src" />
    </div>
    <div class="detail-remarks">
      <p>{{ detailData.content }}</p>
    </div>
    <div class="detail-button-content">
      <div class="left-button">
        <el-button
          type="primary"
          size="small"
          @click="() => this.$router.back()"
          >返回我的订阅列表</el-button
        >
      </div>
      <div class="right-button">
        <el-button plain icon="el-icon-download" size="small" @click="download"
          >下载课件包</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import userService from "@/global/service/user";
import classService from "@/global/service/class";
export default {
  data() {
    return {
      detailData: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    subscribe() {},
    getData() {
      let id = this.$route.params.id;
      userService.coursewareSubDetail(id).then(res => {
        this.detailData = res;
      });
    },
    download() {
      let id = this.$route.params.id;
      classService.coursewareDownload(id).then(() => {
        const el = document.createElement("a");
        document.body.appendChild(el);
        el.href = this.detailData.file.file_src;
        el.download = this.detailData.file.file_name;
        el.target = "_blank";
        el.click();
        document.body.removeChild(el);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  color: #2c3e50;
  .details-mark {
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    /deep/.el-breadcrumb__item {
      font-size: 12px;
    }
  }
  .details-title {
    font-size: 24px;
    padding: 24px 0 10px 0;
    text-align: left;
  }
  .detail-information {
    font-size: 10px;
    text-align: left;
    span {
      color: #efb32f;
    }
  }
  .detail-img {
    padding-top: 20px;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .detail-remarks {
    text-align: left;
    font-size: 12px;
    color: #2c3e50;
    padding: 20px 0;
    text-indent: 2em;
    text-align: left;
  }
  .detail-button-content {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    .right-button {
      display: flex;
      a {
        margin-right: 10px;
      }
    }
  }
}
</style>
